import { render, staticRenderFns } from "./OrderpagePage.vue?vue&type=template&id=b1ca9232"
import script from "./OrderpagePage.vue?vue&type=script&lang=js"
export * from "./OrderpagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports